// 通用格式化工具

// 把 ISO 时间戳格式化为 "YYYY-MM-DD HH:mm"（详细到年月日，并附分钟）
export function formatDateTime(value) {
  if (!value) return '';
  const d = new Date(value);
  if (isNaN(d.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

// 仅日期：YYYY-MM-DD
export function formatDate(value) {
  if (!value) return '';
  const d = new Date(value);
  if (isNaN(d.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

// 性别中文
export function genderLabel(g) {
  switch ((g || '').toLowerCase()) {
    case 'male': return '男';
    case 'female': return '女';
    case 'other': return '其他';
    case 'unspecified': return '保密';
    default: return '';
  }
}
